import { render, staticRenderFns } from "./MenuItemsEditor.vue?vue&type=template&id=04a1624b"
import script from "./MenuItemsEditor.vue?vue&type=script&lang=js"
export * from "./MenuItemsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports